import * as dm from 'generated/api/dm.api';

type CreateClientEvent = dm.paths['/open-api/api/events/createClientEvent'];
export type CreateClientEventParams = CreateClientEvent['post']['parameters']['body']['dto'];
export type ClientEvent = CreateClientEvent['post']['responses']['200']['schema'];
